export function intercomShutdown () {
    if (window.Intercom && typeof window.Intercom === 'function') {
        window.Intercom('shutdown');
    }
}
